import type { Validator } from "@entrilia/shared/utilities/validators";
import {
  combineValidators,
  maxCharactersValidator,
  regexValidator,
  requiredValidator,
} from "@entrilia/shared/utilities/validators";

const MAX_NAME_LENGTH = 80;

// Mirrors the backend's AssistantChatTitles rule; a typed ' is accepted and sent as ’.
export const createAssistantNameValidator = (namesLabel: string): Validator<string> => {
  const trimmedNameValidator = combineValidators(
    requiredValidator,
    maxCharactersValidator(MAX_NAME_LENGTH, `${namesLabel} can be up to ${MAX_NAME_LENGTH} characters`),
    regexValidator(
      /^(?!.*--)[\p{L}\p{M}\p{N} \-:_,()&+’']+$/u,
      `${namesLabel} can use letters, numbers, spaces and - : _ , ( ) & + ’, without --`
    )
  );
  return (name) => trimmedNameValidator(name.trim());
};

export const toTypographicName = (name: string): string => name.replaceAll("'", "’");
